import { IncentiveType } from "./IncentiveType";
import { Territory } from "./Territory";

export interface IIncentiveProgram {
  incentiveProgramId: number;
  name: string;
  code: string;
  active: boolean;
  territory: Territory;
  incentiveType: IncentiveType;
}

export class IncentiveProgram implements IIncentiveProgram {
  public incentiveProgramId: number;
  public name: string;
  public code: string;
  public active: boolean;
  public territory: Territory;
  public incentiveType: IncentiveType;
}
